import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import TopicCard from '@/components/feature/TopicCard';
import { gossipCategories, gossipTopics } from '@/mocks/gossip';
import type { GossipTopic } from '@/types';

export default function HomeTodayHot() {
  const tabs = useMemo(() => gossipCategories.filter((item) => item.slug !== 'all'), []);
  const [active, setActive] = useState<string>('all');

  const list = useMemo<GossipTopic[]>(() => {
    if (active === 'all') return gossipTopics as unknown as GossipTopic[];
    return gossipTopics.filter((item) => item.categorySlug === active) as unknown as GossipTopic[];
  }, [active]);

  return (
    <section className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="Today's Hot"
            title="今日爆点速览"
            desc="按分类切换，挑你感兴趣的口味。每一条都附带时间线、来源和证据完整度标注。"
            action={
              <Link
                to="/topics"
                className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                查看全部瓜料
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </Link>
            }
          />
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-7 flex flex-wrap items-center gap-2">
            <button
              type="button"
              onClick={() => setActive('all')}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-[13px] font-medium transition-colors ${
                active === 'all'
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-50 text-foreground-700 hover:text-primary-700'
              }`}
            >
              全部
            </button>
            {tabs.map((tab) => (
              <button
                key={tab.slug}
                type="button"
                onClick={() => setActive(tab.slug)}
                className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-[13px] font-medium transition-colors ${
                  active === tab.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-700 hover:text-primary-700'
                }`}
              >
                <i className={tab.icon} aria-hidden="true" />
                {tab.name}
              </button>
            ))}
          </div>
        </Reveal>

        {list.length > 0 ? (
          <div className="mt-7 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((topic, index) => (
              <Reveal key={topic.id} delay={index * 60}>
                <div className="h-full">
                  <TopicCard topic={topic} />
                </div>
              </Reveal>
            ))}
          </div>
        ) : (
          <div className="mt-7 rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-14 text-center">
            <i className="ri-inbox-line text-3xl text-foreground-300" aria-hidden="true" />
            <p className="mt-3 text-sm text-foreground-600">这个分类暂时还没有新瓜，换个口味看看？</p>
          </div>
        )}
      </div>
    </section>
  );
}